exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main__wrapper{height:100%}#addAttachmentsToObjects .v--modal-box.v--modal{min-height:260px!important;min-width:695px!important}#addAttachmentsToObjects .modal__footer{display:none}#addAttachmentsToObjects .v-tabs__div{width:50%!important;max-width:none}#addAttachmentsToObjects .v-tabs__slider-wrapper{width:50%!important}#addAttachmentsToObjects .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#addAttachmentsToObjects .complete-inspection__background:hover{cursor:pointer}#addAttachmentsToObjects .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#addAttachmentsToObjects .v-tabs__div:not(:last-child){padding-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-195da082","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/AddAttachmentsToObjects.vue
// module id = 2065
// module chunks = 0